import { Component, Output, EventEmitter, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-text-area',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './text-area.component.html',
  styleUrl: './text-area.component.scss'
})
export class TextAreaComponent {
  @Input() label = '';
  @Input() inputValue = '';
  @Input() type = '';
  @Input() title = '';
  @Input() placeholder = '';
  @Input() error = '';
  @Output() returnValue: EventEmitter<any> = new EventEmitter<string>();
  
  onInputChange(event: any) {
    if (!this.title) {
      this.returnValue.emit(this.inputValue);
    } else {
      this.returnValue.emit({ title: this.title, value: this.inputValue });
    }
  }
}
